module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "overflow": "hidden"
    },
    on: {
      "click": function($event) {
        _vm.$root.activeMobileMenu = false
      }
    }
  }, [_c('v-toolbar', {
    staticStyle: {
      "background-color": "#3A2D01",
      "height": "200px"
    }
  }, [_c('v-toolbar-title', [_c('Logo')], 1)], 1), _vm._v(" "), _c('v-navigation-drawer', {
    staticClass: "submenu",
    staticStyle: {
      "overflow": "hidden"
    },
    attrs: {
      "permanent": "",
      "right": ""
    }
  }, [_c('v-list', {
    staticClass: "listScroll"
  }, [_vm._l((_vm.menu), function(item) {
    return (_vm.canRead(item)) ? _c('v-list-tile', {
      key: item,
      class: ['subMenuItem', _vm.$root.activePage == item.page ? 'active' : ''],
      nativeOn: {
        "click": function($event) {
          _vm.menuClick(item)
        }
      }
    }, [_c('v-list-tile-action', [_c('i', {
      staticClass: "material-icons icon"
    }, [_vm._v(_vm._s(item.icon))])]), _vm._v(" "), (_vm.$root.isRTL) ? _c('v-list-tile-content', [_c('v-list-tile-title', {
      staticStyle: {
        "text-align": "right!important",
        "margin": "10px"
      }
    }, [_vm._v(_vm._s(item.title))])], 1) : _vm._e(), _vm._v(" "), (_vm.showBadge(item)) ? _c('v-list-tile-action', [_c('div', {
      staticClass: "w3-badge"
    }, [_c('b', [_vm._v(_vm._s(_vm.$root.messagesCounter))])])]) : _vm._e()], 1) : _vm._e()
  }), _vm._v(" "), _c('v-list-tile', {
    staticClass: "subMenuItem",
    nativeOn: {
      "click": function($event) {
        _vm.confirmSignout($event)
      }
    }
  }, [_c('v-list-tile-action', [_c('i', {
    staticClass: "material-icons icon"
  }, [_vm._v("lock")])]), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', {
    staticStyle: {
      "text-align": "right!important",
      "margin": "10px"
    }
  }, [_vm._v("יציאה")])], 1)], 1)], 2)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-8e1af1b0"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/SubMenu.vue
// module id = 908
// module chunks = 2